import { apiCall } from "./Interceptor";

const GET_ALL_TRADERS_LIST = "/trader/getAll";
const GET_ROLEID_BY_CAPID = "/trader/getRoleIdForCapacity";

const getAllTradersList = async () => {
    const response = await apiCall.get(GET_ALL_TRADERS_LIST);
    return response;
}

const getRoleIdForCapacity = async (roleType,capId) => {
    const response = await apiCall.get(`${GET_ROLEID_BY_CAPID}?type=${roleType}&capacityId=${capId}`);
    return response;
}

export default {
    getAllTradersList,
    getRoleIdForCapacity,
};
